import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    teamLeaderId: string;
    userId: string;
};

export const schemaUserResolver_IsInTeam = z.boolean();

export type SchemaUserResolver_IsInTeam = z.infer<typeof schemaUserResolver_IsInTeam>;

export type UserResolver_IsInTeam = Resolver<Arguments, SchemaUserResolver_IsInTeam>;
